import React, { useState, useEffect } from 'react';
import { formatPrecio } from '../utils'; // eslint-disable-line no-unused-vars

const BASE_URL = 'https://api.pixventa.com';

const ESTADOS_MX = [
  'Aguascalientes','Baja California','Baja California Sur','Campeche',
  'Chiapas','Chihuahua','Ciudad de México','Coahuila','Colima','Durango',
  'Estado de México','Guanajuato','Guerrero','Hidalgo','Jalisco',
  'Michoacán','Morelos','Nayarit','Nuevo León','Oaxaca','Puebla',
  'Querétaro','Quintana Roo','San Luis Potosí','Sinaloa','Sonora',
  'Tabasco','Tamaulipas','Tlaxcala','Veracruz','Yucatán','Zacatecas'
];

function ConfigEnvio() {
  const [config, setConfig] = useState(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => 
  {
    fetch(`${BASE_URL}/config-envio`)
    .then(r => r.json())
    .then(data => {
      setConfig({
        ...data,
        precio_envio: parseFloat(data.precio_envio).toLocaleString('es-MX', { minimumFractionDigits: 2 }),
        monto_envio_gratis: parseFloat(data.monto_envio_gratis).toLocaleString('es-MX', { minimumFractionDigits: 2 }),
      });
    });
  }, []);

  async function guardar() 
 {
   setGuardando(true);

    const configLimpia = {
      ...config,
      precio_envio: parseFloat(String(config.precio_envio).replace(/,/g, '')) || 0,
      monto_envio_gratis: parseFloat(String(config.monto_envio_gratis).replace(/,/g, '')) || 0,
    };

    await fetch(`${BASE_URL}/config-envio`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(configLimpia),
    });
    setGuardando(false);
    alert('✅ Configuración guardada');
  } 

  if (!config) return <div style={styles.loading}>Cargando...</div>;

  return (
    <div style={styles.container}>

      <div style={styles.secHdr}>
        <span style={styles.secTitle}>Configuración de envío</span>
      </div>

      {/* Opciones de entrega */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>Opciones de entrega</div>

        <div style={styles.toggleRow}>
          <div>
            <div style={styles.toggleLabel}>📦 Envío a domicilio</div>
            <div style={styles.toggleSub}>Los clientes reciben en su casa</div>
          </div>
          <button
            style={{ ...styles.toggle, background: config.envio_activo ? '#25D366' : '#ddd' }}
            onClick={() => setConfig({ ...config, envio_activo: !config.envio_activo })}
          >
            <div style={{ ...styles.toggleThumb, left: config.envio_activo ? 23 : 3 }} />
          </button>
        </div>

        <div style={styles.toggleRow}>
          <div>
            <div style={styles.toggleLabel}>🏪 Recoger en tienda</div>
            <div style={styles.toggleSub}>El cliente pasa a recoger su pedido</div>
          </div>
          <button
            style={{ ...styles.toggle, background: config.recoleccion_activa ? '#25D366' : '#ddd' }}
            onClick={() => setConfig({ ...config, recoleccion_activa: !config.recoleccion_activa })}
          >
            <div style={{ ...styles.toggleThumb, left: config.recoleccion_activa ? 23 : 3 }} />
          </button>
        </div>
      </div>

      {/* Costo de envío */}
      {config.envio_activo && (
        <div style={styles.card}>
          <div style={styles.cardTitle}>Costo de envío</div>

          <div style={styles.toggleRow}>
            <div>
              <div style={styles.toggleLabel}>🎁 Envío gratis</div>
              <div style={styles.toggleSub}>Gratis en todos los pedidos</div>
            </div>
            <button
              style={{ ...styles.toggle, background: config.envio_gratis ? '#25D366' : '#ddd' }}
              onClick={() => setConfig({ ...config, envio_gratis: !config.envio_gratis })}
            >
              <div style={{ ...styles.toggleThumb, left: config.envio_gratis ? 23 : 3 }} />
            </button>
          </div>

          {!config.envio_gratis && (
            <div style={styles.group}>
              <label style={styles.label}>Precio de envío ($MXN)</label>
             <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', 
                  left: 12, 
                  top: '50%', 
                  transform: 'translateY(-50%)',
                  color: '#7A8F89', 
                  fontSize: 14,
                  pointerEvents: 'none'
                }}>$</span>
               <input
                  style={{ ...styles.input, paddingLeft: 24, boxSizing: 'border-box' }}
                  type="text"
                  value={config.precio_envio}
                  onChange={e => setConfig({ ...config, precio_envio: e.target.value.replace(/[^0-9.]/g, '') })}
                  onBlur={e => { const num = parseFloat(e.target.value.replace(/,/g, '')) || 0; setConfig({ ...config, precio_envio: num.toLocaleString('es-MX', { minimumFractionDigits: 2 }) }); }}
                />
              </div>
            </div>
          )}

          {!config.envio_gratis && (
              <div style={styles.group}>
                <label style={styles.label}>Envío gratis a partir de ($MXN) — 0 = desactivado</label>
                <div style={{ position: 'relative' }}>
                  <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#7A8F89', fontSize: 14, pointerEvents: 'none' }}>$</span>
                  <input
                    style={{ ...styles.input, paddingLeft: 24, boxSizing: 'border-box' }}
                    type="text"
                    placeholder="500"
                    value={config.monto_envio_gratis}
                    onChange={e => setConfig({ ...config, monto_envio_gratis: e.target.value.replace(/[^0-9.]/g, '') })}
                    onBlur={e => {
                      const num = parseFloat(e.target.value.replace(/,/g, '')) || 0;
                      setConfig({ ...config, monto_envio_gratis: num.toLocaleString('es-MX', { minimumFractionDigits: 2 }) });
                    }}
                  />
                </div>
              </div>
            )}

          <div style={styles.group}>
            <label style={styles.label}>Tiempo de entrega</label>
            <input
              style={styles.input}
              placeholder="Ej. 2-3 días hábiles"
              value={config.tiempo_entrega || ''}
              onChange={e => setConfig({ ...config, tiempo_entrega: e.target.value })}
            />
          </div>
        </div>
      )}

      {/* Dirección de tienda */}
      {config.recoleccion_activa && (
        <div style={styles.card}>
          <div style={styles.cardTitle}>Datos de tu tienda</div>

          <div style={styles.group}>
            <label style={styles.label}>Dirección completa</label>
            <textarea
              style={{ ...styles.input, height: 80, resize: 'none' }}
              placeholder="Calle, número, colonia, ciudad, CP"
              value={config.direccion_tienda || ''}
              onChange={e => setConfig({ ...config, direccion_tienda: e.target.value })}             
            />
            <div style={styles.group}>
            <label style={styles.label}>Estado</label>
            <select
              style={styles.input}
              value={config.estado_tienda || ''}
              onChange={e => setConfig({ ...config, estado_tienda: e.target.value })}
            >
            <option value="">Selecciona un estado</option>
                {ESTADOS_MX.map(e => (
                <option key={e} value={e}>{e}</option>
                 ))}
            </select>
            </div>
          </div>

          <div style={styles.group}>
            <label style={styles.label}>Horario de atención</label>
            <input
              style={styles.input}
              placeholder="Ej. Lunes a Viernes 10am - 7pm"
              value={config.horario_tienda || ''}
              onChange={e => setConfig({ ...config, horario_tienda: e.target.value })}
            />
          </div>
        </div>
      )}

      <button
        style={{ ...styles.saveBtn, opacity: guardando ? 0.7 : 1 }}
        onClick={guardar}
        disabled={guardando}
      >
        {guardando ? '⏳ Guardando...' : '✓ Guardar configuración'}
      </button>

    </div>
  );
}

const styles = {
  container:    { paddingBottom: 90 },
  loading:      { padding: 40, textAlign: 'center', color: '#7A8F89' },
  secHdr:       { marginBottom: 14, padding: '16px 16px 0' },
  secTitle:     { fontSize: 16, fontWeight: 800, color: '#0D1F1A' },
  card:         { background: 'white', borderRadius: 16, padding: 16, margin: '0 16px 12px', border: '1px solid #E4EDE8', boxShadow: '0 2px 6px rgba(0,0,0,0.05)' },
  cardTitle:    { fontSize: 14, fontWeight: 700, color: '#0D1F1A', marginBottom: 14 },
  toggleRow:    { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, padding: '10px 0', borderBottom: '1px solid #f5f5f5' },
  toggleLabel:  { fontSize: 14, fontWeight: 600, color: '#0D1F1A' },
  toggleSub:    { fontSize: 11, color: '#7A8F89', marginTop: 2 },
  toggle:       { width: 46, height: 26, borderRadius: 13, border: 'none', cursor: 'pointer', position: 'relative', transition: 'background 0.2s', flexShrink: 0 },
  toggleThumb:  { position: 'absolute', top: 3, width: 20, height: 20, background: 'white', borderRadius: '50%', transition: 'left 0.2s', boxShadow: '0 1px 4px rgba(0,0,0,0.2)' },
  group:        { marginBottom: 14 },
  label:        { display: 'block', fontSize: 12, fontWeight: 700, color: '#7A8F89', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6 },
  input:        { width: '100%', background: '#F0F4F0', border: '1.5px solid #E4EDE8', borderRadius: 12, padding: '12px 14px', fontSize: 14, color: '#0D1F1A', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' },
  saveBtn: { background: 'linear-gradient(135deg,#25D366,#128C7E)', color: 'white', border: 'none', borderRadius: 16, padding: 16, fontSize: 15, fontWeight: 700, cursor: 'pointer', margin: '8px 16px', width: 'calc(100% - 32px)' },
};

export default ConfigEnvio;